import axios from 'axios';
import utils from '@/commonProject/helpers/utils';

export default {
    requestServerGet,
    requestServerPost,
    requestServerPut,
    requestServerDelete,
    requestServerPostForSso,
};

//axiosのゲットメソッドでAPI(mock)側へリクエストを行う
async function requestServerGet(url, queryParam, cognitoIdToken) {
    // リクエストヘッダーを作成する。
    let requestHeader = {};

    if (!utils.isNull(queryParam)) {
        // クエリパラメーター格納変数を初期化する。
        let param = {};

        // クエリパラメーターを設定する。
        for (let key in queryParam) {
            param[key] = queryParam[key];
        }
        requestHeader['params'] = param;
    }

    // Cognito ID Tokenをセット。
    if (!utils.isNull(cognitoIdToken)) {
        requestHeader['headers'] = { Authorization: cognitoIdToken };
    }

    // APIをコールする。
    return new Promise((resolve, reject) => {
        axios
            .get(url, requestHeader)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    }).catch((e) => {
        throw e;
    });
}

//axiosのポストメソッドでAPI(mock)側へリクエストを行う
async function requestServerPost(url, formData, cognitoIdToken) {
    // リクエストヘッダーを作成する。
    let requestHeader = {};

    // Cognito ID Tokenをセット。
    if (!utils.isNull(cognitoIdToken)) {
        requestHeader['headers'] = { Authorization: cognitoIdToken };
    }

    return new Promise((resolve, reject) => {
        axios
            .post(url, formData, requestHeader)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    }).catch((e) => {
        throw e;
    });
}

async function requestServerPut(url, formData, cognitoIdToken) {
    // リクエストヘッダーを作成する。
    let requestHeader = {};

    // Cognito ID Tokenをセット。
    if (!utils.isNull(cognitoIdToken)) {
        requestHeader['headers'] = { Authorization: cognitoIdToken };
    }

    return new Promise((resolve, reject) => {
        axios
            .put(url, formData, requestHeader)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    }).catch((e) => {
        throw e;
    });
}

async function requestServerDelete(url, queryParam, cognitoIdToken) {
    // リクエストヘッダーを作成する。
    let requestHeader = {};

    if (!utils.isNull(queryParam)) {
        // クエリパラメーター格納変数を初期化する。
        let param = {};

        // クエリパラメーターを設定する。
        for (let key in queryParam) {
            param[key] = queryParam[key];
        }
        requestHeader['params'] = param;
    }

    // Cognito ID Tokenをセット。
    if (!utils.isNull(cognitoIdToken)) {
        requestHeader['headers'] = { Authorization: cognitoIdToken };
    }

    // APIをコールする。
    return new Promise((resolve, reject) => {
        axios
            .delete(url, requestHeader)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    }).catch((e) => {
        throw e;
    });
}

//axiosのポストメソッドでAPI(mock)側へリクエストを行う
async function requestServerPostForSso(url, formData, authorize) {
    // リクエストヘッダーを作成する。
    const requestHeader = { headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: authorize } };

    return new Promise((resolve, reject) => {
        axios
            .post(url, formData, requestHeader)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    }).catch((e) => {
        throw e;
    });
}
